import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SimpleBar from 'simplebar-react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import { KeysModifiers } from './KeysModifiers'
import { View } from './View'
import { confirmCloseMessage } from '../../actions/disconnect'
import { Platforms } from '../../actions/toolbar'
import { ACCESS_GRANTED } from '../../actions/webrtcConnection'
import ToolbarButton from './ToolbarButton'
import ClipboardButton from './ClipboardButton'
import { AudioChat, AUDIO_CHAT_AREA } from './AudioChat'
import { Permissions } from '../../lib/Permissions'
import { AGENT_TYPE } from '../../actions/agent'

import '../../styles/toolbar.scss'

export const TB_MODALS = {
  AUDIO_CHAT_REQUEST: 'audio-chat-request',
  AUDIO_CHAT_REJECTED: 'audio-chat-rejected'
}

class ToolbarComponent extends Component {

  onClose = () => {
    this.props.confirmCloseMessageAction(true)
  }

  renderSessionArea () {
    const { agentType, unattended, unstable, sessionKey, clientFirstName, clientLastName } = this.props
    let tooltip = null
    if (agentType === AGENT_TYPE.ON_DEMAND) {
      tooltip = this.context.t('tooltip-connected-as', {
        clientFirstName,
        clientLastName,
        permission: Permissions.isMouseKbdAllowed()
          ? this.context.t('permission-full-control')
          : this.context.t('permission-view-only'),
      })
    } else {
      tooltip = this.context.t('tooltip-connected-as-unattended', {
        clientFirstName,
        clientLastName,
      })
    }
    const popover = (
      <Popover id={'session-tooltip'} bsPrefix={'popover tb-popover'}>
        <Popover.Content>
          { tooltip }
        </Popover.Content>
      </Popover>
    )
    const item = unattended ? null : sessionKey
    return (
      <div className={'tbArea tbInfoArea'}>
        <div className={`connected ${unstable ? 'unstable' : 'stable'}`}></div>
        <OverlayTrigger placement='right' overlay={popover}>
          <div className={`${unattended ? 'unattendedAgentInfo' : 'sessionKey'}`}>
            {item}
          </div>
        </OverlayTrigger>
      </div>
    )
  }

  render () {
    const {
      unattended,
      accessState,
      streamNotStarted,
      screenSharing,
      platformType,
      capturingSuspended,
      unstable,
    } = this.props
    if (accessState !== ACCESS_GRANTED) {
      return null
    }

    let videoNotAvailable = false
    if (platformType === Platforms.IOS) {
      videoNotAvailable = (
        streamNotStarted ||
        !screenSharing ||
        unstable ||
        accessState !== 'ACCESS_GRANTED'
      )
    } else {
      videoNotAvailable = (
        capturingSuspended ||
        unstable ||
        accessState !== 'ACCESS_GRANTED'
      )
    }

    return (
      <div className={`toolbar ${unattended ? 'tbUnattendedAgent' : ''}`}>

        {this.renderSessionArea()}

        <SimpleBar className='tbScrollArea'>
          <AudioChat area={AUDIO_CHAT_AREA.PEER} />
          <KeysModifiers videoNotAvailable={videoNotAvailable} />
          <View videoNotAvailable={videoNotAvailable} />
          <AudioChat area={AUDIO_CHAT_AREA.CLIENT} />
          <ClipboardButton />
        </SimpleBar>

        <div className='tbDisconnectArea'>
          <div className='tbDivider' />
          <ToolbarButton
            className='tbDisconnect'
            tooltip={this.context.t(unattended ? 'tb-close-tooltip-unattended' : 'tb-close-tooltip')}
            onClick={this.onClose}
          />
        </div>

      </div>
    )
  }
}

ToolbarComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

ToolbarComponent.propTypes = {
  agentType: PropTypes.string,
  unattended: PropTypes.bool,
  sessionKey: PropTypes.string,
  confirmCloseMessageAction: PropTypes.func.isRequired,
  clientFirstName: PropTypes.string,
  clientLastName: PropTypes.string,
  accessState: PropTypes.any,
  platformType: PropTypes.string,
  unstable: PropTypes.bool,
  streamNotStarted: PropTypes.bool.isRequired,
  screenSharing: PropTypes.bool.isRequired,
  capturingSuspended: PropTypes.bool.isRequired,
  confirmCloseMessage: PropTypes.bool.isRequired,
}

export function mapStateToProps (state) {
  return {
    agentType: state.agent.type,
    unattended: state.agent.unattended,
    sessionKey: state.router.sessionKey,
    clientFirstName: state.signaling.clientFirstName,
    clientLastName: state.signaling.clientLastName,
    accessState: state.webrtcConnection.accessState,
    unstable: state.webrtcConnection.unstable,
    platformType: Object.values(Platforms).includes(state.signaling.agentDetails.platformType)
      ? state.signaling.agentDetails.platformType
      : 'windows',
    streamNotStarted: state.ondemand.streamNotStarted,
    screenSharing: state.ondemand.screenSharing,
    capturingSuspended: state.ondemand.capturingSuspended,
    confirmCloseMessage: state.disconnect.confirmCloseMessage,
  }
}

function mapDispatchToProps (dispatch) {
  return {
    confirmCloseMessageAction: (payload) => {
      dispatch(confirmCloseMessage(payload))
    },
  }
}

export const Toolbar = connect(
  mapStateToProps,
  mapDispatchToProps
)(ToolbarComponent)
